import { render, staticRenderFns } from "./payment-method-grid.vue?vue&type=template&id=2e9f5f96&"
import script from "./payment-method-grid.ts?vue&type=script&lang=ts&"
export * from "./payment-method-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports